import React from 'react';

const Breadcrumbs = ({propertyData}) => {

  
   // Helper function to format the date
   const formatDate = (dateString) => {
    try {
      if (!dateString) throw new Error("Invalid Date");
      
      const date = new Date(dateString);
      if (isNaN(date.getTime())) throw new Error("Invalid Date");

      // Format: "Jan 03, 25"
      const options = { month: 'short', day: '2-digit', year: '2-digit' };
      return date.toLocaleDateString('en-US', options);
    } catch (error) {
      return "Invalid Date";
    }
  };

   // Extract date and property ID safely
   const formattedDate = formatDate(propertyData?.createdAt);
   const propertyId = propertyData?._id || "N/A";


  console.log("propertyDatav2",propertyData)

  return (
    <div className="w-full p-2">
      <div className="container mx-auto ">
        <div className="flex justify-between flex-col sm:flex-row items-start sm:items-center space-y-2 sm:space-y-0">
          <div className="text-gray-700 text-[10px]  font-normal flex flex-wrap gap-1 sm:gap-0">
            <a href="#" className="text-[#606060] hover:text-red-700">Home</a>
            <span className="mx-2">{'>'}</span>
            <a href="#" className="text-[#606060] hover:text-red-700">Property for Sale In Jaipur</a>
            <span className="mx-2">{'>'}</span>
            <a href="#" className="text-[#606060] hover:text-red-700">Flats for Sale In Jaipur</a>
            <span className="mx-2">{'>'}</span>
            <a href="#" className="text-[#606060] hover:text-red-700">Flats for Sale In Vaishali Nagar</a>
            <span className="mx-2">{'>'}</span>
            <a href="#" className="text-[#606060] hover:text-red-700">3 BHK Flats for Sale In Vaishali Nagar</a>
            <span className="mx-2">{'>'}</span>
            <span className="text-gray-700">1195 sq-ft</span>
          </div>
          <div className="text-[#606060] text-xs font-normal  flex flex-col sm:flex-row sm:space-x-3">
            <span>Posted on: { formattedDate || "Jan 03, 25"}</span>
            {/* <span className="mx-2">|</span> */}
              <span>Property ID: {propertyId}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumbs;
